import React, { useState, useEffect } from "react";
import "./VideoGallerySection.css";

// Thumbnail mapping object
const thumbnailMap = {
  "VID-20250121-WA0015 Artur": "https://arely-media.s3.amazonaws.com/VID-20250121-WA0015+Artur.jpg",
  "VID-20250123-WA0000 Artur": "https://arely-media.s3.amazonaws.com/VID-20250123-WA0000+Artur.jpg",
  "VID-20250123-WA0001 Artur": "https://arely-media.s3.amazonaws.com/VID-20250123-WA0001+Artur.jpg",
  "VID-20250123-WA0002 Artur": "https://arely-media.s3.amazonaws.com/VID-20250123-WA0002+Artur.jpg",
  "VID-20250123-WA0003 Artur": "https://arely-media.s3.amazonaws.com/VID-20250123-WA0003+Artur.jpg",
  "VID-20250123-WA0004 Artur": "https://arely-media.s3.amazonaws.com/VID-20250123-WA0004+Artur.jpg",
  "VID-20250123-WA0005 Artur": "https://arely-media.s3.amazonaws.com/VID-20250123-WA0005+Artur.jpg",
  "VID-20250123-WA0007 Artur": "https://arely-media.s3.amazonaws.com/VID-20250123-WA0007+Artur.jpg",
  "VID-20250123-WA0008 Artur": "https://arely-media.s3.amazonaws.com/VID-20250123-WA0008+Artur.jpg",
  "VID-20250123-WA0009 Artur": "https://arely-media.s3.amazonaws.com/VID-20250123-WA0009+Artur.jpg",
  "VID-20250123-WA0011 Artur": "https://arely-media.s3.amazonaws.com/VID-20250123-WA0011+Artur.jpg",
  "VID-20250123-WA0012 Artur": "https://arely-media.s3.amazonaws.com/VID-20250123-WA0012+Artur.jpg",
  "VID-20250123-WA0013 Artur": "https://arely-media.s3.amazonaws.com/VID-20250123-WA0013+Artur.jpg",
  "VID-20250123-WA0014 Artur": "https://arely-media.s3.amazonaws.com/VID-20250123-WA0014+Artur.jpg",
  "VID-20250123-WA0015 Artur": "https://arely-media.s3.amazonaws.com/VID-20250123-WA0015+Artur.jpg",
  "VID-20250123-WA0010 Artur": "https://arely-media.s3.amazonaws.com/VID-20250123-WA0006+Artur.jpg",
  "VID-20250123-WA0010 Artur": "https://arely-media.s3.amazonaws.com/VID-20250123-WA0010+Artur.jpg",
  "VID-20250123-WA0016 Artur": "https://arely-media.s3.amazonaws.com/VID-20250123-WA0016+Artur.jpg"
};

// Helper function to get thumbnail URL for a video
const getThumbnailUrl = (videoUrl) => {
  // Extract the filename without extension
  const match = videoUrl.match(/([^/]+)\.(?:mp4|mov|avi|wmv|flv|mkv|webm|ogg|mpeg)$/i);
  if (!match) return null;
  
  const baseName = match[1];
  return thumbnailMap[baseName] || null;
};

function VideoModal({ videoUrl, onClose, onNext, onPrev, hasNext, hasPrev }) {
  // Prevent clicks inside the modal from closing it
  const handleContentClick = (e) => {
    e.stopPropagation();
  };

  // Handle button clicks separately to prevent modal from closing
  const handlePrevClick = (e) => {
    e.stopPropagation();
    onPrev();
  };

  const handleNextClick = (e) => {
    e.stopPropagation();
    onNext();
  };

  return (
    <div className="video-modal-overlay" onClick={onClose}>
      <div className="video-modal-content" onClick={handleContentClick}>
        <button className="modal-close-btn" onClick={onClose}>×</button>
        
        <div className="modal-video-container">
          {hasPrev && (
            <button 
              className="modal-nav-btn prev" 
              onClick={handlePrevClick}
              type="button"
            >
              ‹
            </button>
          )}
          
          <video
            controls
            autoPlay
            className="modal-video"
            key={videoUrl}
          >
            <source src={videoUrl} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
          
          {hasNext && (
            <button 
              className="modal-nav-btn next" 
              onClick={handleNextClick}
              type="button"
            >
              ›
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

export default function VideoGallerySection() {
  const [videoUrls, setVideoUrls] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedVideo, setSelectedVideo] = useState(null);
  const [selectedIndex, setSelectedIndex] = useState(null);

  useEffect(() => {
    fetch("https://23cvii7l7lfiexqigujv7arwee0zcdaf.lambda-url.us-east-1.on.aws/")
      .then((res) => {
        if (!res.ok) {
          throw new Error(`HTTP error! status: ${res.status}`);
        }
        return res.json();
      })
      .then((data) => {
        // Handle both old format (array) and new format (object with items)
        let videoList = [];

        if (Array.isArray(data)) {
          // Old format: ["url1", "url2", ...]
          videoList = data;
        } else if (data && data.items && Array.isArray(data.items)) {
          // New format: {success: true, items: [{file_name: "..."}, ...]}
          videoList = data.items.map(item =>
            `https://arely-media.s3.us-east-1.amazonaws.com/${item.file_name}`
          );
        } else {
          console.error("Unexpected data format:", data);
          return;
        }

        const videos = videoList.filter((url) =>
          url.match(/\.(mp4|mov|avi|wmv|flv|mkv|webm|ogg|mpeg)$/i)
        );
        setVideoUrls(videos);
      })
      .catch((err) => {
        console.error("Fetch or network error:", err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const handleVideoClick = (url, index) => {
    setSelectedVideo(url);
    setSelectedIndex(index);
    document.body.style.overflow = 'hidden';
  };

  const handleCloseModal = () => {
    setSelectedVideo(null);
    setSelectedIndex(null);
    document.body.style.overflow = 'unset';
  };

  const handlePrevVideo = () => {
    if (selectedIndex > 0) {
      const newIndex = selectedIndex - 1;
      setSelectedVideo(videoUrls[newIndex]);
      setSelectedIndex(newIndex);
    }
  };

  const handleNextVideo = () => {
    if (selectedIndex < videoUrls.length - 1) {
      const newIndex = selectedIndex + 1;
      setSelectedVideo(videoUrls[newIndex]);
      setSelectedIndex(newIndex);
    }
  };

  // Handle keyboard navigation
  useEffect(() => {
    const handleKeyPress = (e) => {
      if (!selectedVideo) return;
      
      switch(e.key) {
        case 'ArrowLeft':
          if (selectedIndex > 0) handlePrevVideo();
          break;
        case 'ArrowRight':
          if (selectedIndex < videoUrls.length - 1) handleNextVideo();
          break;
        case 'Escape':
          handleCloseModal();
          break;
        default:
          break;
      }
    };

    window.addEventListener('keydown', handleKeyPress);
    return () => window.removeEventListener('keydown', handleKeyPress);
  }, [selectedVideo, selectedIndex, videoUrls.length]);

  return (
    <section id="video-gallery" className="section">
      <h2>Video Gallery</h2>

      {loading && (
        <div className="loading-container">
          <div className="loading-spinner"></div>
          <p>Loading videos...</p>
        </div>
      )}

      {!loading && videoUrls.length === 0 && (
        <p className="no-videos-message">
          No videos found or failed to fetch.
        </p>
      )}

      <div className="video-grid">
        {videoUrls.map((url, index) => {
          const thumbnailUrl = getThumbnailUrl(url);
          
          return (
            <div 
              key={index} 
              className="video-item"
              onClick={() => handleVideoClick(url, index)}
            >
              <div className="video-wrapper">
                {thumbnailUrl ? (
                  <img
                    src={thumbnailUrl}
                    alt="Video thumbnail"
                    className="gallery-video"
                  />
                ) : (
                  <video
                    preload="metadata"
                    className="gallery-video"
                  >
                    <source src={url} type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                )}
                <div className="video-overlay">
                  <span className="play-icon">▶</span>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {selectedVideo && (
        <VideoModal
          videoUrl={selectedVideo}
          onClose={handleCloseModal}
          onNext={handleNextVideo}
          onPrev={handlePrevVideo}
          hasNext={selectedIndex < videoUrls.length - 1}
          hasPrev={selectedIndex > 0}
        />
      )}
    </section>
  );
}